import React from 'react';

function A({children, ...props}) {
    return (
        <a {...props}>{children}</a>
    )
}

export default A;